import React from "react";
import "./style.css";

const MatchReport = ({ match, playerStats, cityName, leagueName }) => {
  const mvp = playerStats.find((p) => p.player?.id === match.match_mvp)?.player;

  const goToPlayerProfile = () => {
    if (!mvp) return;
    const url = `/${formatForURL(cityName)}/${formatForURL(leagueName)}/oyuncular/${mvp.id}`;
    window.location.href = url;
  };

  return (
    <div className="match-report">
      <div className="motm-section">
        <h3>Maçın Oyuncusu</h3>
        {mvp ? (
          <div className="motm-card" onClick={goToPlayerProfile}>
            <img src={mvp.player_img} alt={mvp.player_name} className="motm-img" />
            <div>
              <strong>{mvp.player_name}</strong>
              <p>Profili Görüntüle →</p>
            </div>
          </div>
        ) : (
          <p>Henüz MVP belirlenmedi.</p>
        )}
      </div>

      <div className="match-comment-section">
        <h3>Maç Yorumu</h3>
        <div className="match-comment-box">
          {match.match_comment || "Maç yorumu henüz eklenmedi."}
        </div>
      </div>
    </div>
  );
};

const formatForURL = (str) => {
  return str
    .toLowerCase()
    .replace(/ç/g, "c")
    .replace(/ğ/g, "g")
    .replace(/ı/g, "i")
    .replace(/ö/g, "o")
    .replace(/ş/g, "s")
    .replace(/ü/g, "u")
    .replace(/[^a-z0-9 ]/g, "")
    .trim()
    .replace(/\s+/g, "-");
};

export default MatchReport;
